'use client'

import { OverlayView } from '@react-google-maps/api'
import { cn } from '@repo/ui/lib'

import { useMapContext } from './context.tsx'

export const Markers = () => {
  const { markerList } = useMapContext()

  return (
    <>
      {markerList?.map(({ lat, lng }, idx) => {
        return (
          <OverlayView
            key={idx}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            position={{ lat: parseFloat(lat), lng: parseFloat(lng) }}
          >
            <div
              className={cn(
                'bg-brand',
                `ml-[-5px] mt-[-5px] h-2.5 w-2.5`,
                idx + 1 === markerList.length ? '' : 'rounded-[10pxy]',
              )}
            />
          </OverlayView>
        )
      })}
    </>
  )
}
